/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:4407fc10-8ea1-44e5-b8fe-b8da54618284",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_UOpG1VawI",
    "aws_user_pools_web_client_id": "2c6jddu6bo7i3u18rrplu4sjkf",
    "oauth": {},
    "aws_dynamodb_all_tables_region": "ap-south-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "MasterTable-dev",
            "region": "ap-south-1"
        }
    ],
    "aws_user_files_s3_bucket": "base-app-storage132841-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "BaseAPI",
            "endpoint": "https://wg4qhm6ara.execute-api.ap-south-1.amazonaws.com/dev",
            "region": "ap-south-1"
        }
    ],
    "aws_content_delivery_bucket": "dev.itraff.ivldsp.in-dev",
    "aws_content_delivery_bucket_region": "ap-south-1",
    "aws_content_delivery_url": "https://dum9ik9bt0srt.cloudfront.net"
};


export default awsmobile;
